// Shared markdown stripper — used by both the gateway (server-side TTS) and the
// client (useVoice). Keep in sync if either copy changes.
export function stripMarkdown(text: string): string {
  return text
    .replace(/```[\s\S]*?```/g, "")             // fenced code blocks
    .replace(/`[^`]+`/g, "")                     // inline code
    .replace(/!\[([^\]]*)\]\([^)]+\)/g, "")      // images → remove (before links)
    .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")     // links → label only
    .replace(/#{1,6}\s+/g, "")                   // heading markers
    .replace(/\*{2,3}(.*?)\*{2,3}/g, "$1")       // **bold** / ***bolditalic*** → keep text
    .replace(/(?<!\*)\*([^*\n]+)\*(?!\*)/g, "$1") // *italic/embodied* → keep text, strip markers
    .replace(/_{2,3}(.*?)_{2,3}/g, "$1")         // __bold__ / ___bolditalic___ → keep text
    .replace(/(?<!_)_([^_\n]+)_(?!_)/g, "$1")   // _italic_ → keep text
    .replace(/~~(.*?)~~/g, "$1")                 // strikethrough
    .replace(/^\s*[-*+]\s+/gm, "")              // unordered list markers
    .replace(/^\s*\d+\.\s+/gm, "")             // ordered list markers
    .replace(/\n{3,}/g, "\n\n")                 // collapse excess newlines
    .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '')   // control chars + DEL
    .replace(/[‪-‮⁦-⁩]/g, '')        // BiDi overrides (U+202A–U+202E, U+2066–U+2069)
    .trim();
}
